import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 请求车位列表
export const getCarList = params => {
    return get("/admin/carport", params);
};

// 修改信息
export const editCar = params => {
    return put(`/admin/carport/${params.id}`, params);
};

// 添加车位
export const addCar = params => {
    return post("/admin/carport", params);
};

// 删除车位
export const deleteCar = params => {
    return del(`/admin/carport/${params}`);
};
// 批量删除
export const delscar = params => {
    const datas = {
        ids: params
    }
    return post(`admin/carport/del`, datas)
}


// WEBPACK FOOTER //
// ./src/api/parking.js